import { isEmpty } from 'lodash-es';
import { shallow } from 'zustand/shallow';
import { IS_USE_PLEX_API } from '../../../constants';
import { CasinoTypeUnion } from '../../../types';
import { useGamesStore } from '../../store';
import { selectCategories } from '../helpers';

export const useCategories = (
  feedName: string,
  casinoType?: CasinoTypeUnion
) => {
  return useGamesStore((store) => {
    const categories =
      IS_USE_PLEX_API && casinoType
        ? store.lobbies[casinoType]?.categories
        : store.feeds[feedName]?.categories;
    return isEmpty(categories) ? [] : selectCategories(categories);
  }, shallow);
};
